import { msgExpireDurationOptions } from '@/configs/options';
import { ChatCategory } from '@/contexts/chat/scripts/hooks/useChats/types';
import { useSessionContext } from '@/contexts/session/context';
import styles from './index.module.scss';
import VectorIcon from './images/vector.svg?react';
import KeyErrorIcon from './images/keyError.svg?react';
import type { MyAvatarProps } from './type';
import { TagTypes } from './type';
import singleAvatar from './images/defaultSingle.png';
import groupAvatar from './images/defaultGroup.png';

const defaultAvatars: Record<string, string> = {
  [ChatCategory.SINGLE]: singleAvatar,
  [ChatCategory.GROUP]: groupAvatar,
};

const MyAvatar = ({
  className,
  size = 'medium',
  src,
  tagType,
  info = {},
  expireDuration,
  showProfileClick = true,
  stopPropagation = true,
  category = ChatCategory.SINGLE,
  onClick,
}: MyAvatarProps) => {
  const { setShowProfileInfo } = useSessionContext();
  const [loading, setLoading] = useState(true);
  const TagTypesData = useMemo(
    () => ({
      [TagTypes.DESTROY]:
        !!expireDuration &&
        msgExpireDurationOptions.findByValue(expireDuration)?.avatarIcon,
      [TagTypes.VECTOR]: <VectorIcon />,
      [TagTypes.KEYERROR]: (
        <Tooltip placement="bottom" title="The user's network error(10).">
          <KeyErrorIcon />
        </Tooltip>
      ),
    }),
    [expireDuration]
  );

  const defaultAvatar = useMemo(() => {
    return defaultAvatars[category];
  }, [category]);

  const myAvatarCls = {
    [styles.hoverable]: showProfileClick || !!onClick,
    [className as string]: className,
  };

  const handleOnClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (stopPropagation) {
      e.stopPropagation();
    }

    onClick?.();
    // TODO GROUP
    if (showProfileClick && category === ChatCategory.SINGLE) {
      setShowProfileInfo({
        show: true,
        info: {
          ...info,
          category,
          avatar: info.avatar || src,
          userId: info.userId || info.user_id,
        },
      });
    }
  };

  return (
    <div
      className={cls(styles.myAvatar, styles[size], myAvatarCls)}
      onClick={handleOnClick}
    >
      {loading && <img src={defaultAvatar} />}
      <img
        style={{ display: loading ? 'none' : 'block' }}
        src={src}
        alt="avatar"
        onError={(e) => {
          e.currentTarget.src = defaultAvatar;
        }}
        onLoad={() => {
          setLoading(false);
        }}
      />
      {tagType && <div className={styles.tag}>{TagTypesData[tagType]}</div>}
    </div>
  );
};
export default MyAvatar;
